const printSection = (target, styles) => {
  if (target) {
    const contents = target.outerHTML

    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    document.body.appendChild(iframe)

    const doc = iframe.contentWindow.document

    doc.open()
    doc.write(`
      <html>
        <head>
          <link rel="stylesheet" href="${styles}" type="text/css">
        </head>
        <body>
          ${contents}
        </body>
      </html>
    `)
    doc.close();

    iframe.contentWindow.addEventListener('afterprint', () => {
      document.body.removeChild(iframe)
    })

		setTimeout(() => iframe.contentWindow.print(), 100)

  } else {
    console.log('Missing print target.')
  }
}
window.printSection = printSection
